import { useCallback, useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { getCustomerGroups } from "../../../services";
import { CustomerGroup } from "../../../types/customer.type";
import { ApiResponse } from "../../../types/express-data.type";

interface CustomerGroupsState {
  groups: CustomerGroup[];
  loading: boolean;
  reload: () => void;
}

/** Every customer group (GET /customer-groups answers with the whole list, no paging). */
export function useCustomerGroups(): CustomerGroupsState {
  const [groups, setGroups] = useState<CustomerGroup[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [reloadCount, setReloadCount] = useState<number>(0);

  useEffect(() => {
    let isLatest = true;
    const loadGroups = async () => {
      setLoading(true);
      try {
        const response: AxiosResponse<ApiResponse<CustomerGroup[]>> = await getCustomerGroups();
        if (isLatest) setGroups(response.data.data ?? []);
      } catch {
        // Surfaced by the axios interceptor; the list stays as it was.
      } finally {
        if (isLatest) setLoading(false);
      }
    };
    loadGroups();
    return () => {
      isLatest = false;
    };
  }, [reloadCount]);

  const reload = useCallback(() => setReloadCount((count) => count + 1), []);

  return { groups, loading, reload };
}
